import apiPath from "./constants/apiPath";

export let mainSocket = null;

let reconnectInterval = null;
let reconnectAttempts = 0;
const MAX_RECONNECT_ATTEMPTS = 10;
let latestToken = null;
let isManualDisconnect = false;

export const sendMainSocketEvent = (payload, logLabel = "event") => {
  if (!payload || typeof payload !== "object") return false;
  if (!mainSocket || mainSocket.readyState !== WebSocket.OPEN) {
    console.warn(`[Socket] ${logLabel} skipped, socket not open`, {
      readyState: mainSocket?.readyState,
      payload,
    });
    return false;
  }
  mainSocket.send(JSON.stringify(payload));
  console.log(`[Socket] ${logLabel} sent`, payload);
  return true;
};

export const connectMainSocket = (token) => {
  if (!token) return;
  latestToken = token;
  isManualDisconnect = false;

  try {
    // Prevent duplicate connections from repeated calls.
    if (
      mainSocket &&
      (mainSocket.readyState === WebSocket.OPEN ||
        mainSocket.readyState === WebSocket.CONNECTING)
    ) {
      return;
    }

    console.log("websocketurl===>", `${apiPath.socketURL}`);

    // Browsers cannot send custom headers in WebSockets natively, 
    // so we pass the token using the Sec-WebSocket-Protocol header (subprotocols)
    const socket = new WebSocket(`${apiPath.socketURL}`, ["Token", token]);
    const currentSocket = socket;
    mainSocket = currentSocket;

    socket.onopen = () => {
      console.log("✅ Main WebSocket Connected");

      reconnectAttempts = 0;

      // stop retry loop if connected
      if (reconnectInterval) {
        clearTimeout(reconnectInterval);
        reconnectInterval = null;
      }
    };

    socket.onmessage = function (event) {
      try {
        const data = JSON.parse(event.data);

        console.log("📩 SOCKET EVENT:", data);
        window.dispatchEvent(
          new CustomEvent("app-socket-message", {
            detail: data,
          }),
        );

        // 🔴 FORCE LOGOUT
        if (data.type === "force_logout") {
          alert(data.message || "Logged in from another device");

          disconnectMainSocket();

          localStorage.clear();
          window.location.href = "/login";
        }

        // 💬 TICKET MESSAGE
        if (data.type === "ticket_message") {
          console.log("New Ticket Message:", data.data);
        }

        // 🔔 NOTIFICATION
        if (data.type === "notification") {
          console.log("Notification:", data.data);
          window.dispatchEvent(
            new CustomEvent("app-notification", {
              detail: data.data || data,
            }),
          );
        }

        // 💰 WALLET UPDATE
        if (data.type === "wallet_update") {
          console.log("Wallet Updated:", data.data);
        }

      } catch (e) {
        console.error("Socket parse error", e);
      }
    };

    socket.onerror = function (e) {
      console.error("Socket error", e);
    };

    socket.onclose = function (e) {
      console.log("❌ Socket Closed", e);
      if (mainSocket !== currentSocket) return;
      mainSocket = null;

      // 🔥 AUTO RECONNECT
      if (!isManualDisconnect && reconnectAttempts < MAX_RECONNECT_ATTEMPTS) {
        const delay = Math.min(3000 * (reconnectAttempts + 1), 10000);

        console.log(`🔄 Reconnecting in ${delay / 1000}s...`);

        reconnectInterval = setTimeout(() => {
          reconnectAttempts++;
          connectMainSocket(latestToken || token);
        }, delay);
      } else {
        console.error("❌ Max reconnect attempts reached");
      }
    };
  } catch (e) {
    console.error("Failed to connect socket", e);
  }
};

export const disconnectMainSocket = () => {
  isManualDisconnect = true;
  const socketToClose = mainSocket;
  mainSocket = null;

  if (socketToClose) {
    try {
      socketToClose.close();
    } finally {
      // no-op
    }
  }

  if (reconnectInterval) {
    clearTimeout(reconnectInterval);
    reconnectInterval = null;
  }
  reconnectAttempts = 0;
};